export default "__VITE_ASSET__cEAVF2PI__"